import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";

interface LinkBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
}

export interface FormLinkBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: LinkBlockMeta;
  hidden?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormLinkBlock = forwardRef<HTMLDivElement, FormLinkBlockProps>(
  (
    {
      label = "Link",
      placeholder = "",
      required = false,
      hidden = false,
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => (
    <FieldElementBlock
      ref={ref}
      blockInstanceMeta={blockInstanceMeta}
      fieldType="link"
      hidden={hidden}
      label={label}
      placeholder={placeholder}
      required={required}
      {...rest}
    />
  ),
);

FormLinkBlock.displayName = "FormLinkBlock";
